module.exports = __webpack_public_path__ + "assets/b102.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b102.png
// module id = 573
// module chunks = 0